import lodash from "lodash"
import Figure from "@src/components/atoms/Figure"
import CTAction from "@src/components/molecules/CTAction"
import YoutubeVideo from "@src/components/molecules/YoutubeVideo"

const serializers = {
  types: {
    figure: Figure,
    cta: CTAction,
    youtubeVideo: YoutubeVideo,
  },
}

export const serializeLoyaltyProgramTips = (tips): string[] => {
  return Object.keys(tips).map(key => tips[key] && key)
}

const serializeName = (name: string) => {
  const parts = name.split(" ")
  if (parts.length > 2) {
    return `${parts[0]} ${parts[2]}`
  }
  return name
}

export const serializeCsvData = (fields: any, entries: any) => {
  const list: any = []
  const serializeFields: any = {}
  fields.forEach((field, index) => {
    serializeFields[lodash.camelCase(field)] = index
  })

  entries.forEach(values => {
    const entry = {
      id: values[serializeFields.referralUrl],
      name: values[serializeFields.name].trim(),
      points: values[serializeFields.points],
    }
    if (entry.name && entry.id) {
      list.push({
        id: entry.id.replace(/[^0-9]+/g, ""),
        name: serializeName(entry.name),
        points: Number(entry.points),
      })
    }
  })
  return list
}

export default serializers
